import "./App.css";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { darkTheme, lightTheme } from "./themes";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes/Routes";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "./store/Store";
import { GetPrice } from "./store/actions/price/PriceActions";
import AlertModal from "./components/organisms/alert/AlertModal";
import { AlertModalModel } from "./models/AlertModal.model";
import { SetAlert } from "./store/actions/alert/AlertActions";
import i18n from "./i18nextConf";
import SnackbarProvider from "react-simple-snackbar";
import { LIVE_PRICE } from "./api-calls";
import ErrorBoundary from "./ErrorBoundary";
import { useInstallPWA } from "./components/organisms/InstallationBanner/hooks";
import InstallationBanner from "./components/organisms/InstallationBanner";
import { isMobile } from "react-device-detect";
import { useTranslation } from "react-i18next";

export const GlobalStyle = createGlobalStyle`
  body {
    background: ${(props: any) => props.theme.bgColor1};
    direction: ${i18n.dir()};
    font-family: 'IRANSansXFaNum';
    overflow-x: hidden;
  }
`;

function App() {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [getPriceOnce, setGetPriceOnce] = useState(false);
  const onCloseAlertModal = () => {
    let data: AlertModalModel = {
      btnText: "",
      message: "",
      title: "",
      type: "error",
      show: false,
    };
    dispatch(SetAlert(data));
    setShowAlert(false);
  };
  const { i18n } = useTranslation();

  useEffect(() => {
    document.body.setAttribute('data-lang', i18n.language);
  }, [i18n.language]);

  /**
   * Get General State Of The App
   */
  const GeneralState = useSelector((state: RootStore) => state.general);
  const [theme, setTheme] = useState(
    GeneralState.theme ? GeneralState.theme : "dark"
  );
  useInstallPWA(); // should be called to dispatch action of before install event on page reload
  const [pwaBannerVisible, setPWABannerVisible] = useState<boolean>(false);

  useEffect(() => {
    const getSymbolPrice = async () => {
      LIVE_PRICE()
        .then(
          (res) => {
            dispatch(GetPrice(res.data.data));
          },
          (error) => {}
        )
        .catch((error) => console.log(error));
    };
    if (!getPriceOnce) {
      setGetPriceOnce(true);
      getSymbolPrice();
    }
    return () => {};
  }, [getPriceOnce, dispatch]);

  useEffect(() => {
    setTheme(GeneralState.theme);
  }, [GeneralState.theme]);

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <SnackbarProvider>
        {/*// @ts-ignore*/}
        <ErrorBoundary>
          <div className="App">
            <Router basename={`${process.env.PUBLIC_URL}`}>
              <>
                <GlobalStyle />
                <Routes></Routes>
              </>
            </Router>
            <AlertModal show={showAlert} handleClose={onCloseAlertModal} />
            {isMobile && (
              <InstallationBanner
                visible={pwaBannerVisible}
                setVisible={setPWABannerVisible}
              />
            )}
          </div>
        </ErrorBoundary>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;

